// SegmentPersonaZone, German.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Segment persona': 'Segment-Persona',
  'who we want to meet · written held, because you are its author':
    'wen wir treffen wollen · übernommen geschrieben, weil Sie die Urheberin sind',
  'New segment': 'Neues Segment',
  'loading…': 'wird geladen…',
  'The segments could not be read: {error}': 'Die Segmente konnten nicht gelesen werden: {error}',
  'No segment persona yet. A segment persona is your own form — titles, seniorities, departments, sectors, cantons, topics — and is written held on the spot, because you are its author. It is what a sequence addresses and what a lookalike search is built from.':
    'Noch keine Segment-Persona. Eine Segment-Persona ist Ihr eigenes Formular — Funktionen, Senioritäten, Abteilungen, Branchen, Kantone, Themen — und wird sofort übernommen geschrieben, weil Sie die Urheberin sind. Sie ist das, was eine Sequenz anspricht und woraus eine Lookalike-Suche gebaut wird.',

  'Name': 'Name',
  'Titles': 'Funktionen',
  'Seniorities': 'Senioritäten',
  'Departments': 'Abteilungen',
  'Sectors': 'Branchen',
  'Cantons': 'Kantone',
  'Topics': 'Themen',
  'Directions générales du social vaudois': 'Directions générales du social vaudois',
  'Hold this segment': 'Segment übernehmen',
  'Comma-separated. A field you leave empty is not a criterion. Sectors and cantons choose which organisations of your own record the search is anchored to; topics cannot be searched on Surfe and the answer says so.':
    'Kommagetrennt. Ein leeres Feld ist kein Kriterium. Branchen und Kantone bestimmen, an welchen Organisationen Ihres eigenen Bestands die Suche verankert wird; Themen lassen sich bei Surfe nicht suchen, und die Antwort sagt das.',
  'A segment persona needs a name.': 'Eine Segment-Persona braucht einen Namen.',
  'Could not write the segment persona.': 'Die Segment-Persona konnte nicht geschrieben werden.',
  '{name} held as version {n}.': '{name} als Version {n} übernommen.',

  'version': 'Version',
  'titles': 'Funktionen',
  'seniorities': 'Senioritäten',
  'departments': 'Abteilungen',
  'sectors': 'Branchen',
  'cantons': 'Kantone',
  'topics': 'Themen',

  'Find lookalikes': 'Lookalikes suchen',
  'Searching…': 'Wird gesucht…',
  'Searches Surfe for people like this segment and files each as a candidate proposal':
    'Sucht bei Surfe nach Personen wie in diesem Segment und reicht jede als Kandidatenvorschlag ein',
  '{n} candidates proposed. They wait in Review; none is on the record.':
    '{n} Kandidaten vorgeschlagen. Sie warten in der Prüfung; keiner steht im Bestand.',
  'Nothing new: {known} of the answers are already on the record.':
    'Nichts Neues: {known} der Antworten stehen bereits im Bestand.',
  'The lookalike search failed.': 'Die Lookalike-Suche ist fehlgeschlagen.',
  '{proposed} proposed of {requested} asked': '{proposed} vorgeschlagen von {requested} angefragt',
  '{known} already on the record': '{known} bereits im Bestand',
  '{used} of {cap} today': '{used} von {cap} heute',
  'not searchable on Surfe: {list}': 'bei Surfe nicht suchbar: {list}',
  '{n} company pages asked of the scout': '{n} Firmenseiten beim Scout angefragt',
  'Seniorities are Surfe’s own ten words and nothing else is accepted: {list}. Anything you write is matched to one of them or refused here, so a segment cannot be saved that no search could ever run.':
    'Senioritäten sind Surfes eigene zehn Wörter, etwas anderes wird nicht angenommen: {list}. Was Sie schreiben, wird einem davon zugeordnet oder hier abgelehnt — so lässt sich kein Segment speichern, dessen Suche nie laufen könnte.',
  'Review the candidates': 'Kandidaten prüfen',
}, 'SegmentPersonaZone');
